"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Row = function (_a) {
    var faq = _a.faq, index = _a.index;
    return (react_1.default.createElement("li", { className: "coCategoryFaqRow-Container" },
        react_1.default.createElement("div", { className: "coCategoryFaqRow-Header" },
            react_1.default.createElement("div", { className: "coCategoryFaqRow-Header_Label" },
                "Q",
                index),
            react_1.default.createElement("div", { className: "coCategoryFaqRow-Header_Title" }, faq.content)),
        react_1.default.createElement("div", { className: "coCategoryFaqRow-Body" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: "coCategoryFaqRow-Body_Label" }, "A")),
            react_1.default.createElement("div", { className: "coCategoryFaqRow-Body_Answer" }, faq.answer))));
};
exports.default = Row;
